export default __webpack_public_path__ + "static/media/Contact_BG-01.9fde7e00.png";